import { useContext } from "react";
import { AuthContext, type AuthState } from "./AuthProvider.tsx";

export function useAuthSession(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuthSession must be used inside <AuthProvider>");
  }
  return ctx;
}
